var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-card shadow-sm",attrs:{"data-name":_vm.name,"id":_vm.kebabCase(_vm.name)}},[_c('h4',{staticClass:"mb-4 text-xl font-weight-bold text-gray-500"},[_vm._v(_vm._s(_vm.name))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }